/**
 * Tenký WebSocket klient. API žije na <base>/api/ — v dev módu to proxuje
 * Vite na lokální server, v produkci nginx.
 */

export const API_BASE = `${import.meta.env.BASE_URL}api/`;

export class Net {
  constructor({ onMessage, onClose }) {
    this.onMessage = onMessage;
    this.onClose = onClose;
    this.ws = null;
  }

  get connected() {
    return this.ws?.readyState === WebSocket.OPEN;
  }

  connect() {
    return new Promise((resolve, reject) => {
      const proto = location.protocol === 'https:' ? 'wss' : 'ws';
      const ws = new WebSocket(`${proto}://${location.host}${API_BASE}ws`);
      this.ws = ws;

      ws.onopen = () => resolve();
      ws.onerror = () => reject(new Error('Nepodařilo se připojit k serveru'));
      ws.onclose = () => {
        if (this.ws === ws) {
          this.ws = null;
          this.onClose?.();
        }
      };
      ws.onmessage = (e) => {
        try {
          this.onMessage(JSON.parse(e.data));
        } catch {
          /* ignorujeme nevalidní zprávy */
        }
      };
    });
  }

  send(obj) {
    if (this.connected) this.ws.send(JSON.stringify(obj));
  }

  close() {
    const ws = this.ws;
    this.ws = null; // úmyslné zavření nespouští onClose
    ws?.close();
  }
}

export async function fetchLeaderboard() {
  const res = await fetch(`${API_BASE}leaderboard?limit=10`);
  if (!res.ok) throw new Error('leaderboard fetch failed');
  return (await res.json()).leaderboard;
}
